(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hc-cookie-preferences"] && !Shopify.designMode) return;
  try {
    let hcPrivacyPromise;
function hcLoadPrivacy(){
  if(window.Shopify?.customerPrivacy)return Promise.resolve(window.Shopify.customerPrivacy);
  if(!hcPrivacyPromise)hcPrivacyPromise=new Promise((resolve,reject)=>{
    if(!window.Shopify?.loadFeatures){reject(new Error('Unavailable'));return;}
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>error?reject(error):resolve(window.Shopify.customerPrivacy));
  }).catch(error=>{hcPrivacyPromise=null;throw error;});
  return hcPrivacyPromise;
}
document.addEventListener('click',async event=>{
  const dialog=document.getElementById('hc-cookie-dialog');
  if(!dialog)return;
  const opener=event.target.closest('[data-cookie-preferences]');
  if(opener){
    if(window.privacyBanner?.showPreferences){try{await window.privacyBanner.showPreferences();return;}catch(error){}}
    dialog.showModal();
    try{const privacy=await hcLoadPrivacy();const values=privacy.currentVisitorConsent();for(const input of dialog.querySelectorAll('[data-consent-key]'))input.checked=values[input.dataset.consentKey]==='yes';}catch(error){const message=dialog.querySelector('[data-consent-error]');message.textContent=message.dataset.message;}
  }
  const save=event.target.closest('[data-consent-save],[data-consent-necessary]');
  if(!save)return;
  save.disabled=true;
  const message=dialog.querySelector('[data-consent-error]');message.textContent='';
  try{
    const privacy=await hcLoadPrivacy();const values={};
    for(const input of dialog.querySelectorAll('[data-consent-key]'))values[input.dataset.consentKey]=save.hasAttribute('data-consent-necessary')?false:input.checked;
    privacy.setTrackingConsent(values,()=>{dialog.close();save.disabled=false;});
  }catch(error){message.textContent=message.dataset.message;save.disabled=false;}
});
  } catch(e) { console.error(e); }
})();

})();
